// Inscrição de notificações push da Área dos Trabalhadores (Web Push/VAPID).
// A chave pública vem do backend (evita rebuild do frontend em troca de chave).
import { wapi } from "@/lib/api";

const base64UrlToUint8Array = (value) => {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
};

export const pushSupport = () => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) {
    return "unsupported";
  }
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  if (isIOS && !standalone) return "ios-install"; // iPhone: só após "Adicionar à Tela de Início"
  if (Notification.permission === "denied") return "denied";
  return "ok";
};

// Deve ser chamado a partir de um clique (exigência dos navegadores, sobretudo iOS).
export const enablePush = async () => {
  const support = pushSupport();
  if (support !== "ok") throw new Error(support);

  const registration = await navigator.serviceWorker.register("/push-sw.js", { scope: "/" });
  await navigator.serviceWorker.ready;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error(permission === "denied" ? "denied" : "dismissed");

  const { data } = await wapi.get("/workers/push/public-key");
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: base64UrlToUint8Array(data.publicKey),
    });
  }
  await wapi.post("/workers/push/subscribe", subscription.toJSON());
  return subscription;
};

export const disablePush = async () => {
  try {
    const registration = await navigator.serviceWorker.getRegistration("/push-sw.js");
    const subscription = await registration?.pushManager.getSubscription();
    if (subscription) {
      await wapi.post("/workers/push/unsubscribe", { endpoint: subscription.endpoint });
      await subscription.unsubscribe();
    }
  } catch { /* sem push ativo ou já removido */ }
};

export const hasActivePush = async () => {
  try {
    const registration = await navigator.serviceWorker.getRegistration("/push-sw.js");
    return !!(await registration?.pushManager.getSubscription());
  } catch {
    return false;
  }
};
